"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyConfirmationModal = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Pharmacy_service_1 = __importDefault(require("../../../../services/Pharmacy.service"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const atome_1 = require("../../../atome");
const PharmacyConfirmation_web_styles_1 = require("./PharmacyConfirmation.web.styles");
const UtilityFunctions_1 = require("../../../../helper/UtilityFunctions");
const PharmacyConfirmationModal = ({ navigation, pharmacy, confirmationModal, setConfirmationModal, setCurrentPage, }) => {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const pharmaciesList = (0, hooks_1.useAppSelector)(reducers_1.selectPharmacies);
    const creationMode = pharmacy.id === undefined;
    const dispatch = (0, hooks_1.useAppDispatch)();
    const patientComesFromFUPRequest = () => {
        return ((0, UtilityFunctions_1.isInObject)(prescriptionInfo, 'isSamePharmacy') &&
            prescriptionInfo.isSamePharmacy === false);
    };
    const returnToFUPRequest = (newPhramacyIdOrName) => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 9,
            },
        };
        let newPharmacyName;
        if (typeof newPhramacyIdOrName === 'number') {
            const chosenPharmacy = pharmaciesList.find(item => item.id === newPhramacyIdOrName);
            newPharmacyName = chosenPharmacy?.name;
        }
        if (typeof newPhramacyIdOrName === 'string') {
            newPharmacyName = newPhramacyIdOrName;
        }
        dispatch((0, reducers_1.setPrescriptionInfo)({
            ...prescriptionInfo,
            newPharmacy: newPharmacyName,
        }));
        setCurrentPage(reducerType);
        navigation.navigate('FollowPrescription');
    };
    const chosePharmacy = async () => {
        const data = {
            pharmacyId: pharmacy.id,
            patientId: parseInt(userInformation.id),
        };
        const response = await Pharmacy_service_1.default.savePatientPharmacyRelation(data);
        if (!response.error) {
            const newUserInformation = { ...userInformation };
            newUserInformation.patientPharmacyRelation = pharmacy;
            dispatch((0, reducers_1.setUserInformation)(newUserInformation));
        }
        setConfirmationModal(false);
        patientComesFromFUPRequest()
            ? returnToFUPRequest(data.pharmacyId)
            : navigation.navigate('PharmacyPage');
    };
    const createPharmacy = async () => {
        const data = {
            patientId: parseInt(userInformation.id),
            name: pharmacy.name,
            street: pharmacy.street,
            postcode: pharmacy.postcode,
            city: pharmacy.city,
            phone: pharmacy.phone,
            houseNumber: pharmacy.houseNumber,
        };
        const response = await Pharmacy_service_1.default.createPharmacy(data);
        if (!response.error) {
            pharmacy.id = response.data.data.id;
            await chosePharmacy();
            patientComesFromFUPRequest()
                ? returnToFUPRequest(pharmacy.name)
                : navigation.navigate('PharmacyPage');
        }
        setConfirmationModal(false);
    };
    return (react_1.default.createElement(atome_1.Modal, { modalVisible: confirmationModal, setModalVisible: setConfirmationModal, primaryButtonText: "Diese Apotheke w\u00E4hlen", cb: creationMode ? createPharmacy : chosePharmacy },
        react_1.default.createElement(react_native_1.View, { style: PharmacyConfirmation_web_styles_1.styles.modalWeb },
            react_1.default.createElement(atome_1.Text, { style: [PharmacyConfirmation_web_styles_1.styles.modalTitle] }, "Angaben pr\u00FCfen"),
            react_1.default.createElement(atome_1.Text, { style: [PharmacyConfirmation_web_styles_1.styles.modalText] }, "M\u00F6chten Sie diese Apotheke w\u00E4hlen?"),
            react_1.default.createElement(react_native_1.View, { style: [PharmacyConfirmation_web_styles_1.styles.modalText] },
                react_1.default.createElement(atome_1.Text, { style: [PharmacyConfirmation_web_styles_1.styles.heading3Modal] }, pharmacy.name),
                react_1.default.createElement(atome_1.Text, { style: [PharmacyConfirmation_web_styles_1.styles.heading4Modal] }, (pharmacy.street ? pharmacy.street + ' ' : '') +
                    (pharmacy.houseNumber ?? '')),
                react_1.default.createElement(atome_1.Text, { style: [PharmacyConfirmation_web_styles_1.styles.heading4Modal] }, (pharmacy.postcode ? pharmacy.postcode + ' ' : '') +
                    (pharmacy.city ?? ''))))));
};
exports.PharmacyConfirmationModal = PharmacyConfirmationModal;
